import "@mantine/core/styles.css";

import { Button, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import Loader from "@/components/loader";
import { Outlet } from "react-router-dom";
import { apiUserGetAllEmployeesForUser } from "@/api";
import { useData } from "@/utility/state/contextAPI";
import { useEffect } from "react";

function App() {
  const {
    auth: { contextSetJwtToken, jwtToken },
    modal: { isSpinnerModalOpen, modalContent, isModalOpen },
  } = useData();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const title = typeof modalContent === "object" ? modalContent?.title : "";
  const content =
    typeof modalContent === "object" ? modalContent?.content : modalContent;

  useEffect(() => {
    const checkCompanyAndRedirect = async () => {
      const localJwtToken = localStorage.getItem("jwtToken");
      const localCompanyId = localStorage.getItem("companyId");

      //  沒登入的情況
      // if (!jwtToken) {
      //   if (localJwtToken) {
      //     contextSetJwtToken(localJwtToken);
      //   } else if (!["/login", "/signUp"].includes(pathname)) {
      //     navigate(`/login`);
      //     return;
      //   }
      // }

      // 沒有選擇company身份
      if (
        jwtToken &&
        !localCompanyId &&
        !["/companyListPage", "/addCompanyListPage"].includes(pathname)
      ) {
        if (!["/login", "/signUp"].includes(pathname)) {
          try {
            const employeesResponse = await apiUserGetAllEmployeesForUser();
            const hasCompanies =
              employeesResponse?.data && employeesResponse.data.length > 0;

            if (hasCompanies) {
              navigate(`/companyListPage`);
            } else {
              navigate(`/addCompanyListPage`);
            }
          } catch (error) {
            console.error("Error checking companies:", error);
            navigate(`/companyListPage`);
          }
          return;
        }
      }

      // 有登入＋有選擇company身份
      if (
        jwtToken &&
        localCompanyId &&
        ["/login", "/signUp", "/"].includes(pathname)
      ) {
        navigate(`/companyListPage`);
      }
    };

    checkCompanyAndRedirect();
  }, [pathname, jwtToken]);

  return (
    <div className="App min-h-screen bg-[#CCCCCC]">
      <Loader isLoading={isSpinnerModalOpen} />
      <Modal
        open={isModalOpen}
        {...(typeof modalContent === "string"
          ? { content: modalContent }
          : modalContent)}
        title={title}
      >
        {content}
      </Modal>
      <Outlet />
    </div>
  );
}

export default App;
